import { PartialNullable } from "../../Extensions";
import { PropertyChange } from "../../PropertyChange";
import { Property, PropertyBoolean } from "../../RadObject";
import { ElementRef } from "../ElementRef";
import { JsxFragment } from "../JsxFragment";
import { Control, ControlPropertyValues, IControl } from "./Control";
import { NAMESPACE } from "./_Namespace";

import "./ToolbarItem.scss";

export type ToolbarItemPropertyValues =
    ControlPropertyValues
    & {
        dividing: boolean;
        showLabel: boolean;
    };

export type ToolbarItemProperties = {
    [name in keyof ToolbarItemPropertyValues]: Property<ToolbarItemPropertyValues[name]>
};

export interface IToolbarItem extends IControl, ToolbarItemProperties
{
}

export abstract class ToolbarItem extends Control implements IToolbarItem
{
    // #region Static

    public static override classNamespace = NAMESPACE + "ToolbarItem";
    public static override className = "ToolbarItem";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<ToolbarItemPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                dividing: false,
                showLabel: false,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected _containerElementRef!: ElementRef;

    // #endregion

    // #region Properties

    public dividing!: PropertyBoolean;
    public showLabel!: PropertyBoolean;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<ToolbarItemPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-toolbar-item");

        // Trigger Property Changes
        this.dividing.triggerChange();
        this.showLabel.triggerChange();
    }

    // #endregion

    // #region Protected Methods

    protected _dividingChanged(change: PropertyChange<boolean>)
    {
        if (change.currentValue)
            this.addCssClass("rad-style-dividing");
        else
            this.removeCssClass("rad-style-dividing");
    }
    protected _showLabelChanged(change: PropertyChange<boolean>)
    {
        if (change.currentValue)
            this.addCssClass("rad-style-show-label");
        else
            this.removeCssClass("rad-style-show-label");
    }

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: ToolbarItemPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this._containerElementRef = new ElementRef();

        this.dividing = new PropertyBoolean(this, propertyValues.dividing, this._dividingChanged);
        this.showLabel = new PropertyBoolean(this, propertyValues.showLabel, this._showLabelChanged);
    }

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <div>
                <span ref={this._containerElementRef} class="rad-container">
                    {children}
                </span>
            </div>
        );
    }

    // #endregion

    // #endregion
}

